module.exports = __webpack_public_path__ + "static/media/title-instruc.71fe4a10.png";